import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { GiLotusFlower } from 'react-icons/gi';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL;

const AdminLogin = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/auth/login`, form);
      login(res.data.token);
      toast.success('Welcome back! 🙏');
      navigate('/admin/dashboard');
    } catch {
      toast.error('Invalid credentials');
    }
    setLoading(false);
  };

  const inputStyle = {
    width: '100%', padding: '0.9rem 1.2rem',
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(212,175,55,0.4)',
    borderRadius: '10px', color: '#F5D76E',
    fontFamily: 'Crimson Text', fontSize: '1.1rem',
    outline: 'none', marginBottom: '1.2rem',
    transition: 'border 0.3s'
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #1a0800, #2C1810, #1a0800)',
      padding: '2rem'
    }}>
      <motion.div
        initial={{ opacity: 0, y: 40, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.6 }}
        style={{
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(212,175,55,0.3)',
          borderRadius: '20px', padding: '3rem',
          width: '100%', maxWidth: '420px',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 30px 60px rgba(0,0,0,0.5)'
        }}>

        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <motion.div animate={{ rotate: [0, 10, -10, 0] }} transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}>
            <GiLotusFlower size={48} color="#D4AF37" />
          </motion.div>
          <h1 style={{ fontFamily: 'Cinzel', color: '#F5D76E', fontSize: '1.4rem', letterSpacing: '4px', margin: '1rem 0 0.3rem' }}>
            ADMIN LOGIN
          </h1>
          <p style={{ color: '#8B6914', fontFamily: 'Crimson Text', fontSize: '1rem' }}>
            Swarn Dhoop Dashboard
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <label style={{ color: '#c9a96e', fontFamily: 'Inter', fontSize: '0.75rem', letterSpacing: '2px' }}>EMAIL</label>
          <input style={inputStyle} type="email" placeholder="Admin email"
            value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />

          <label style={{ color: '#c9a96e', fontFamily: 'Inter', fontSize: '0.75rem', letterSpacing: '2px' }}>PASSWORD</label>
          <input style={inputStyle} type="password" placeholder="••••••••"
            value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />

          <motion.button whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}
            type="submit" disabled={loading}
            style={{
              width: '100%', padding: '1rem',
              background: 'linear-gradient(135deg, #D4AF37, #FF6B00)',
              color: '#fff', border: 'none', borderRadius: '10px',
              fontFamily: 'Cinzel', fontSize: '0.95rem', letterSpacing: '3px',
              cursor: 'pointer', marginTop: '0.5rem',
              boxShadow: '0 8px 25px rgba(212,175,55,0.3)'
            }}>
            {loading ? 'Entering...' : 'ENTER DASHBOARD'}
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLogin;